import { createContext } from "react";

import type { RegionId, TciInputs, TciResult, WorkflowId } from "@/lib/tci";

export const TCI_SESSION_STORAGE_KEY = "tci-calculator-session";

export type TciSession = {
  /** Null until the user picks a workflow on /client/workflow. */
  workflowId: WorkflowId | null;
  regionId: RegionId | null;
  businessSector: string | null;
  /** Company / organisation name collected on intro. */
  organisationName: string;
  labor: {
    headcount: string;
    timePercent: number;
    salary: string;
  };
  yieldPenalty: {
    volume: string;
    penaltyPerEvent: string;
  };
  untapped: {
    volume: string;
    actionablePercent: number;
    valuePerAction: string;
  };
  annualEbitda: string;
  email: string;
  consent: boolean;
};

export type TciSessionContextValue = {
  session: TciSession | null;
  startSession: (workflowId: WorkflowId) => void;
  updateSession: (partial: DeepPartialSession) => void;
  resetSession: () => void;
  buildTciInputs: () => TciInputs | null;
  result: TciResult | null;
};

/** Shallow-friendly partial updates for nested session fields. */
export type DeepPartialSession = {
  workflowId?: WorkflowId | null;
  regionId?: RegionId | null;
  businessSector?: string | null;
  organisationName?: string;
  labor?: Partial<TciSession["labor"]>;
  yieldPenalty?: Partial<TciSession["yieldPenalty"]>;
  untapped?: Partial<TciSession["untapped"]>;
  annualEbitda?: string;
  email?: string;
  consent?: boolean;
};

export const TciSessionContext = createContext<TciSessionContextValue | null>(
  null,
);
